import { fetchMainBanner as fetchMainBannerApi, fetchTopBanner as fetchTopBannerApi } from '../api';
import { Env } from '@/shared/config/environment';
import { LocalStore } from '@/shared/lib/local-storage';

const state = {
  topBanner: {
    list: [],
    isLoading: false,
    error: null,
  },
  mainBanner: {
    list: [],
    isLoading: false,
    error: null,
  },
  viewedMainBanner: new LocalStore('main_banner_').get('viewed', false),
};

const mutations = {
  SET_TOP_BANNERS_LIST(state, topBanners) {
    state.topBanner.list = topBanners;
  },
  SET_LOADING_TOP_BANNERS(state, isLoading) {
    state.topBanner.isLoading = isLoading;
  },
  SET_TOP_BANNERS_ERROR(state, error) {
    state.topBanner.error = error;
  },
  SET_MAIN_BANNERS_LIST(state, mainBanners) {
    state.mainBanner.list = mainBanners;
  },
  SET_LOADING_MAIN_BANNERS(state, isLoading) {
    state.mainBanner.isLoading = isLoading;
  },
  SET_MAIN_BANNERS_ERROR(state, error) {
    state.mainBanner.error = error;
  },
  SET_MAIN_BANNER_VIEWED(state, viewed) {
    state.viewedMainBanner = viewed;
    new LocalStore('main_banner_').set('viewed', viewed);
  },
};

const actions = {
  async fetchTopBanner({ commit, dispatch }) {
    commit('SET_LOADING_TOP_BANNERS', true);
    commit('SET_TOP_BANNERS_ERROR', null);
    commit('SET_TOP_BANNERS_LIST', null);

    try {
      const banners = await fetchTopBannerApi();
      commit('SET_TOP_BANNERS_LIST', banners);

      return banners;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити рекламні банери';

      commit('SET_TOP_BANNERS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити рекламні банери',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_TOP_BANNERS', false);
    }
  },
  async fetchMainBanner({ commit, dispatch }) {
    commit('SET_LOADING_MAIN_BANNERS', true);
    commit('SET_MAIN_BANNERS_ERROR', null);
    commit('SET_MAIN_BANNERS_LIST', null);

    try {
      const banners = await fetchMainBannerApi();
      commit('SET_MAIN_BANNERS_LIST', banners);

      return banners;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити рекламні банери';

      commit('SET_MAIN_BANNERS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити рекламні банери',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_MAIN_BANNERS', false);
    }
  },
  setMainBannerViewed({ commit }, viewed) {
    commit('SET_MAIN_BANNER_VIEWED', viewed);
  },
};

const getters = {
  isLoadingTopBanner: state => state.topBanner.isLoading,
  isLoadingMainBanner: state => state.mainBanner.isLoading,
  topBannerError: state => state.topBanner.error,
  mainBannerError: state => state.mainBanner.error,
  isTopBannerReady: state => state.topBanner.isLoading === false && state.topBanner.list !== null,
  isMainBannerReady: state => state.mainBanner.isLoading === false && state.mainBanner.list !== null,

  getTopBanner: state => state.topBanner.list,
  getMainBanner: state => state.mainBanner.list,

  isShowMainBanner: state => !state.viewedMainBanner,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
